<script lang="ts">
</script>

<main>
  <div class="row">
    <div class="col align-self-center mb-3">
      <a
        type="button"
        class="btn btn-outline-primary btn-lg actions-button"
        href="https://mukundbhudia.github.io/wembley-events/wembley-events.ics"
        rel="noopener"
        target="_blank">Download ics file</a
      >
      <a
        type="button"
        class="btn btn-outline-secondary btn-lg actions-button"
        href="https://mukundbhudia.github.io/wembley-events/wembley-events.json"
        rel="noopener"
        target="_blank">Download JSON</a
      >
    </div>
  </div>
</main>

<style>
  main {
    text-align: center;
  }

  .actions-button {
    margin-bottom: 10px;
  }
</style>
